import React, { useEffect, useState, useRef } from "react";
import {
  Box, Dialog, IconButton, Tooltip
} from '@mui/material';
import dayjs from "dayjs";
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
const relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);

export default function EssayViewQuestion ({
  question
}){
  const [isValid, setIsValid] = useState(false);
  const [isLongText, setIsLongText] = useState(false);
  const [isShowMore, setIsShowMore] = useState(false);
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');
  const [textShow, setTextShow] = useState('');
  const [imagePreview, setImagePreview] = React.useState({ open: false, src: '', alt: '' });
  
  useEffect(()=>{
    if(!question){
      setIsValid(false);
      return;
    }
    setIsValid(true);
    questionInfoBind();
  }, [question]);

  const maxWordCount = 20;
  const questionInfoBind = ()=>{
    setTitle(question.title);
    var _text = (question.transcribe && question.transcribe.length>1) ? '' : question.topic;
    setText(_text);
    var _words = _text.split(' ');
    if(_words.length>maxWordCount){
      setIsLongText(true);
      setTextShow(_words.slice(0, maxWordCount).join(" ") + "...");
    }
    else{
      setTextShow(_text);
      setIsLongText(false);
    }
  }
  const toggleShowMore = ()=>{
    var _showMore = !isShowMore;
    var _text = text;
    var _words = _text.split(' ');
    if(!_showMore && _words.length>maxWordCount){
      setTextShow(_words.slice(0, maxWordCount).join(" ") + "...");
    }
    else{
      setTextShow(_text);
    }
    setIsShowMore(_showMore);
  }

  const openImagePreview = (b64, alt='') => {
    setImagePreview({ open: true, src: `data:image/png;base64,${b64}`, alt });
  };
  const closeImagePreview = () => setImagePreview({ open: false, src: '', alt: '' });


  return(
    <>
    { isValid &&
    <Box>
    <Box sx={{  display: "flex", alignItems: "flex-start" }}>
      <Box sx={{ flex: 1 }}>
      <div style={{fontSize:'16px', marginBottom:'4px', fontWeight: 700 }}>{title}</div>
      <div style={{fontSize:'14px', marginBottom:'4px'}}>{textShow}
        { isLongText &&
        <span onClick={()=>toggleShowMore()} style={{ color: "blue", cursor: "pointer" }}>
          {isShowMore ? " Show Less" : " Show More"}
        </span>
        }
      </div>
      </Box>
        {question.images != "" && question.images != null && 
        <Box 
          sx={{
            flexShrink: 0,
            width: 'auto',
            height: 120,
            maxWidth: 120, 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative'
          }}
        >
          <Tooltip title="Click to view full image" arrow>
            <IconButton
            onClick={(e) => {
              e.stopPropagation();
              openImagePreview(question.images, title);
            }}
            sx={{
              position: 'absolute',
              top: "50%", 
              left: "50%", 
              transform: "translate(-50%, -50%)", 
              color: 'rgba(255, 255, 255, 0.8)', 
              backgroundColor: 'rgba(0, 0, 0, 0.5)', 
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                boxShadow: 3,
              },
            }}>
              <OpenInFullIcon />
            </IconButton>
          </Tooltip>
        <img
        src={`data:image/png;base64,${question.images}`}
        alt={title}
        style={{
          width: 'auto',
          height: '100%',
          objectFit: 'contain', 
          borderRadius: '4px',
          cursor: 'pointer',
          border: '1px solid #a3a3a4ff', 
        }}
        onClick={(e) => {
          e.stopPropagation(); // Prevent triggering the card click
          // Open image in same window as pop-up
          openImagePreview(question.images, title);
        }}
        />
        {/* <img
        src={`data:image/png;base64,${question.images}`}
        alt={title}
        sx={{marginTop:'0.25rem'}}
        // style={{ width: '2rem' }}
        onClick={() => {
          const byteCharacters = atob(question.images);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'image/png' });  // Create Blob from binary data
          const blobUrl = URL.createObjectURL(blob);

          window.open(blobUrl, '_blank');
        }}
      /> */}
      </Box>
        } 
      </Box>
      <Dialog open={imagePreview.open} onClose={closeImagePreview} maxWidth="md" fullWidth>
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'center', boxShadow: 1  }}>
              {/* using the already-built data URL */}
              <img
                src={imagePreview.src}
                alt={imagePreview.alt || 'Preview'}
                style={{ maxWidth: '100%', height: 'auto' }}
                onClick={(e) => e.stopPropagation()} // avoid bubbling
              />
            </Box>
          </Dialog>
    </Box>
          
    }
    </>
  );
}